<tran-ui-content-wrapper>
    <div class="flex flex-row pb-16 pt-16 gap-8 flex-wrap">
        <h1 class="text-4xl font-bold">{{ 'applications.overview.title' | translate }}</h1>
        @if (!isLoadingApplications() && applications().length) {
            <a routerLink="/apply" class="btn btn-primary text-truncate ms-auto">
                {{ 'applications.overview.create-button' | translate }}
            </a>
        }
    </div>
    @for (application of applications(); track application.id) {
        @let appProgress = progressByApplicationId()[application.id];
        <tran-application-tile
            [application]="application"
            [actions]="tileActions"
            [progress]="appProgress"
            (actionClicked)="onTileAction($event)"
        >
            <div select="[slot=below]" class="flex flex-row justify-content-end gap-6">
                @if (application.status === ApplicationStatus.Draft) {
                    <button class="btn btn-primary" (click)="editApplication(application.id)">
                        {{ 'applications.tile.continue-editing' | translate }}
                    </button>
                }
                @if (application.status !== ApplicationStatus.Draft) {
                    <button class="btn btn-secondary" (click)="showApplicationDetails(application.id)">
                        {{ 'applications.tile.view-details' | translate }}
                    </button>
                }
            </div>
        </tran-application-tile>
    }
    @if (isLoadingApplications()) {
        <div class="flex justify-center items-center h-64">
            <si-loading-spinner />
        </div>
    } @else {
        @if (!applications().length) {
            <div class="flex flex-col items-center justify-center h-64 gap-4">
                <span class="text-xl">
                    {{ 'applications.overview.no-applications-message' | translate }}
                </span>
                <span class="text-secondary pb-4">
                    {{ 'applications.overview.no-applications-secondary-message' | translate }}
                </span>
                <a routerLink="/apply" class="btn btn-primary">
                    {{ 'applications.overview.create-button' | translate }}
                </a>
            </div>
        }
    }
</tran-ui-content-wrapper>

<ng-template #deleteDraftModal>
    <div class="modal-header" (keydown.escape)="hideDeleteDraftModal('cancel')">
        <h4 class="modal-title">{{ 'applications.overview.delete-draft-modal.title' | translate }}</h4>
        <button
            type="button"
            class="btn btn-circle btn-ghost element-cancel btn-lg"
            [attr.aria-label]="'applications.overview.delete-draft-modal.close' | translate"
            (click)="hideDeleteDraftModal('cancel')"
        ></button>
    </div>

    <div class="modal-body">
        <p>
            {{ 'applications.overview.delete-draft-modal.info' | translate }}
        </p>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="hideDeleteDraftModal('cancel')">
            <i class="icon element-undo"></i>{{ 'applications.overview.delete-draft-modal.edit' | translate }}
        </button>

        <button type="button" class="btn btn-danger" (click)="hideDeleteDraftModal('confirm')">
            <i class="icon element-delete"></i>{{ 'applications.overview.delete-draft-modal.send' | translate }}
        </button>
    </div>
</ng-template>
